import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { AccountTemplate } from 'components/Templates'

const Account: FC = () => {
  return (
    <Layout headline={'店舗アカウント設定'} iconPath={'/icon/white/setting.svg'} title={'店舗アカウント設定'}>
      <AccountTemplate />
    </Layout>
  )
}

export default Account
